import React from 'react';
import ChatBot from './components/ChatBot';

function App() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="w-full max-w-lg h-[600px] flex flex-col">
        <ChatBot />
      </div>
    </div>
  );
}

export default App;